module.exports = __webpack_public_path__ + "img/swiperimg2.bd9ef58a.jpg";